// Mirrors the backend rule: approve needs no notes; changes_requested needs
// non-empty notes; any other decision is not submittable.
export function canSubmitSignoff(decision: string, notes: string): boolean {
  if (decision === 'approved') return true;
  if (decision === 'changes_requested') return notes.trim().length > 0;
  return false;
}
